/**
 * Bambe collection ad pin: ?p=PRODUCT_ID[&v=VARIANT_ID]
 * If the product is in the collection, move/inject it as the first grid item.
 * With &v=, the pinned card is re-fetched for that variant so it shows that colour.
 * Visual cue is optional (section settings on #product-grid data attrs).
 */
(function () {
  'use strict';

  var PIN_ATTR = 'data-bambe-pinned';
  var ID_ATTR = 'data-product-id';
  var VARIANT_ATTR = 'data-bambe-pin-variant';
  var cardCache = {};

  function getRoot() {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    if (root.slice(-1) !== '/') root += '/';
    return root;
  }

  function readDigitsParam(name) {
    try {
      var v = new URLSearchParams(window.location.search).get(name);
      if (v && /^\d+$/.test(String(v).trim())) return String(v).trim();
    } catch (e) {}
    return '';
  }

  function readPinFromUrl() {
    return readDigitsParam('p');
  }

  function rememberPin(id) {
    if (!id) return;
    window.__bambePinProductId = id;
    window.__bambePinVariantId = readDigitsParam('v');
    window.__bambePinCollectionPath = window.location.pathname;
  }

  function getPinId() {
    var fromUrl = readPinFromUrl();
    if (fromUrl) {
      rememberPin(fromUrl);
      return fromUrl;
    }
    if (
      window.__bambePinProductId &&
      window.__bambePinCollectionPath === window.location.pathname
    ) {
      return String(window.__bambePinProductId);
    }
    return '';
  }

  function getPinVariantId() {
    if (readPinFromUrl()) return readDigitsParam('v');
    if (
      window.__bambePinVariantId &&
      window.__bambePinCollectionPath === window.location.pathname
    ) {
      return String(window.__bambePinVariantId);
    }
    return '';
  }

  function getGrid() {
    return document.getElementById('product-grid');
  }

  function collectionPath(grid) {
    var url = (grid && grid.getAttribute('data-collection-url')) || window.location.pathname;
    try {
      if (url.indexOf('http') === 0) {
        var u = new URL(url);
        return u.pathname.replace(/\/$/, '') || u.pathname;
      }
    } catch (e) {}
    return String(url).replace(/\/$/, '') || '/collections/all';
  }

  function highlightEnabled(grid) {
    return grid && grid.getAttribute('data-pin-highlight') === 'true';
  }

  function highlightStyle(grid) {
    return (grid && grid.getAttribute('data-pin-style')) || 'border';
  }

  function badgeLabel() {
    var lang = (document.documentElement.getAttribute('lang') || '').toLowerCase();
    if (lang.indexOf('fr') === 0) return 'Sélection';
    return 'مميز';
  }

  function clearHighlight(item) {
    if (!item) return;
    item.classList.remove(
      'bambe-pin-item',
      'bambe-pin-item--border',
      'bambe-pin-item--badge',
      'bambe-pin-item--glow'
    );
    var badge = item.querySelector('.bambe-pin-badge');
    if (badge) badge.remove();
  }

  // ⭐ Featured badge (Theme settings → Bambé — Badge: Featured) on the pinned card. One badge per card: it replaces
  // the card's other badges and the theme's % label. Grid data attrs come from main-collection-product-grid.
  function applyFeaturedBadge(grid, item) {
    var text = grid && grid.getAttribute('data-bambe-feat');
    if (!text || item.querySelector('.bambe-badge--featured')) return;
    var inner = item.querySelector('.card__inner');
    if (!inner) return;
    var stack = inner.querySelector('.absolute.left-12.top-12');
    if (!stack) {
      stack = document.createElement('div');
      stack.className = 'absolute left-12 top-12';
      inner.appendChild(stack);
    }
    var badge = document.createElement('div');
    badge.className = 'table mb-5 tp-prd-item__label bambe-badge bambe-badge--featured bambe-anim-' +
      (grid.getAttribute('data-bambe-feat-anim') || 'none');
    var other = stack.querySelector('.tp-prd-item__label');
    // Keep only the card's badge shape; colours come from the Featured settings, not the badge it replaces
    var radius = other && other.style.getPropertyValue('--border-radius');
    if (radius) badge.style.setProperty('--border-radius', radius);
    var label = document.createElement('div');
    label.className = 'label-inner';
    label.textContent = text;
    badge.appendChild(label);
    Array.prototype.forEach.call(stack.querySelectorAll('.tp-prd-item__label:not(.pre-order)'), function (el) {
      el.remove();
    });
    stack.insertBefore(badge, stack.firstChild);
  }

  function applyHighlight(grid, item) {
    applyFeaturedBadge(grid, item);
    clearHighlight(item);
    if (!highlightEnabled(grid)) return;
    var style = highlightStyle(grid);
    item.classList.add('bambe-pin-item', 'bambe-pin-item--' + style);
    if (style === 'badge' && !item.querySelector('.bambe-pin-badge')) {
      var el = document.createElement('span');
      el.className = 'bambe-pin-badge';
      el.textContent = badgeLabel();
      item.insertBefore(el, item.firstChild);
    }
  }

  function findItems(grid, productId) {
    return Array.prototype.slice.call(
      grid.querySelectorAll('.tp-grid__item[' + ID_ATTR + '="' + productId + '"]')
    );
  }

  // With variantId, only a card already fetched for that variant counts.
  function ensureAtTop(grid, productId, variantId) {
    var items = findItems(grid, productId);
    if (!items.length) return false;

    var keep = items[0];
    if (variantId) {
      keep = null;
      for (var j = 0; j < items.length; j++) {
        if (items[j].getAttribute(VARIANT_ATTR) === variantId) {
          keep = items[j];
          break;
        }
      }
      if (!keep) return false;
      items.splice(items.indexOf(keep), 1);
      items.unshift(keep);
    }
    for (var i = 1; i < items.length; i++) {
      items[i].remove();
    }

    keep.setAttribute(PIN_ATTR, 'true');
    if (grid.firstElementChild !== keep) {
      grid.insertBefore(keep, grid.firstElementChild);
    }
    applyHighlight(grid, keep);
    return true;
  }

  function fetchCollectionProduct(collectionUrlPath, productId) {
    var path = collectionUrlPath;
    if (path.charAt(0) !== '/') path = '/' + path;
    var page = 1;
    var maxPages = 20;

    function next() {
      if (page > maxPages) return Promise.resolve(null);
      var url =
        path +
        '/products.json?limit=250&page=' +
        page +
        '&_=' +
        Date.now();
      return fetch(url, { credentials: 'same-origin' })
        .then(function (res) {
          if (!res.ok) return null;
          return res.json();
        })
        .then(function (data) {
          if (!data || !data.products || !data.products.length) return null;
          var found = data.products.find(function (p) {
            return String(p.id) === String(productId);
          });
          if (found) return found;
          if (data.products.length < 250) return null;
          page += 1;
          return next();
        })
        .catch(function () {
          return null;
        });
    }

    return next();
  }

  function handleFromItem(item) {
    var a = item && item.querySelector('a[href*="/products/"]');
    if (!a) return '';
    var m = (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
    if (!m) return '';
    try {
      return decodeURIComponent(m[1]);
    } catch (e) {
      return m[1];
    }
  }

  function fetchProductCard(handle, variantId) {
    var url = getRoot() + 'products/' + encodeURIComponent(handle) + '?view=card';
    if (variantId) url += '&variant=' + encodeURIComponent(variantId);
    if (cardCache[url] != null) return Promise.resolve(cardCache[url]);
    return fetch(url, { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) return '';
        return res.text();
      })
      .then(function (html) {
        if (html) cardCache[url] = html;
        return html;
      });
  }

  // The card view has no section context, so copy this grid's image shape onto it.
  function matchGridImageShape(grid, li) {
    var ref = grid.querySelector(
      '.tp-grid__item:not([' + PIN_ATTR + '="true"]) .tp__product-main-img .tp__responsive-image'
    );
    if (!ref) return;
    var ratio = ref.style.getPropertyValue('--aspect-ratio');
    var fit = ref.classList.contains('tp-img-fit');
    Array.prototype.forEach.call(li.querySelectorAll('.tp__img-url .tp__responsive-image'), function (el) {
      if (ratio) el.style.setProperty('--aspect-ratio', ratio);
      else el.style.removeProperty('--aspect-ratio');
      el.classList.toggle('tp-img-fit', fit);
    });
  }

  // global.js tpLazyloadImg only observes images present at page load; do the same for injected cards.
  function revealImages(li) {
    var imgs = li.querySelectorAll('.tp-image-js img');
    if (!imgs.length) return;
    function reveal(img, rect) {
      img.width = rect.width;
      img.height = rect.height;
      img.sizes = rect.width + 'px';
      img.classList.add('tp-loaded-image');
      var wrap = img.closest('.tp-image-js');
      if (wrap) wrap.classList.remove('tp-loading-image');
    }
    if (!window.IntersectionObserver) {
      Array.prototype.forEach.call(imgs, function (img) {
        reveal(img, img.getBoundingClientRect());
      });
      return;
    }
    var obs = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          reveal(entry.target, entry.boundingClientRect);
          obs.unobserve(entry.target);
        });
      },
      { rootMargin: '10px' }
    );
    Array.prototype.forEach.call(imgs, function (img) {
      obs.observe(img);
    });
  }

  function injectCard(grid, productId, html, variantId) {
    if (!html || !html.trim()) return false;
    var li = document.createElement('li');
    li.className = 'tp-grid__item';
    li.setAttribute(ID_ATTR, productId);
    li.setAttribute(PIN_ATTR, 'true');
    if (variantId) li.setAttribute(VARIANT_ATTR, variantId);
    li.innerHTML = html.trim();
    matchGridImageShape(grid, li);
    findItems(grid, productId).forEach(function (old) {
      old.remove();
    });
    grid.insertBefore(li, grid.firstElementChild);
    revealImages(li);
    applyHighlight(grid, li);
    try {
      if (window.tpCountdownTimer && typeof window.tpCountdownTimer.init === 'function') {
        window.tpCountdownTimer.init();
      }
      if (
        window.tpColorSwatchesShopify &&
        typeof window.tpColorSwatchesShopify.init === 'function'
      ) {
        window.tpColorSwatchesShopify.init();
      }
    } catch (e) {}
    return true;
  }

  function hasActiveFilters() {
    try {
      var params = new URLSearchParams(window.location.search);
      var skip = { p: true, page: true, sort_by: true, section_id: true };
      var active = false;
      params.forEach(function (_v, key) {
        if (!skip[key] && (key.indexOf('filter.') === 0 || key === 'q')) active = true;
      });
      return active;
    } catch (e) {
      return false;
    }
  }

  // filter.v.option.* values in the URL (e.g. the age picked in the pop-up), grouped by filter key.
  function optionFilterGroups() {
    var groups = {};
    try {
      new URLSearchParams(window.location.search).forEach(function (v, key) {
        if (key.indexOf('filter.v.option.') !== 0 || !v) return;
        (groups[key] = groups[key] || []).push(String(v).trim());
      });
    } catch (e) {}
    return Object.keys(groups).map(function (k) {
      return groups[k];
    });
  }

  function fetchProductJs(handle) {
    return fetch(getRoot() + 'products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (res) {
        return res.ok ? res.json() : null;
      })
      .catch(function () {
        return null;
      });
  }

  // Ad variant's colour in the filtered size: an in-stock variant whose filtered option(s) match a picked value
  // and whose other options match the ad variant. '' = none (the filter's own card stays).
  function filteredVariantId(product, variantId) {
    if (!product || !product.variants) return '';
    var base = product.variants.find(function (v) {
      return String(v.id) === String(variantId);
    });
    if (!base || !base.options) return '';
    var groups = optionFilterGroups();
    var values = (product.options || []).reduce(function (all, o) {
      return all.concat(o.values || []);
    }, []);
    // A filter none of this product's options has (e.g. an age it doesn't come in) = not in this grid
    var missing = groups.some(function (g) {
      return !g.some(function (fv) {
        return values.indexOf(fv) !== -1;
      });
    });
    if (missing) return '';
    var filters = [].concat.apply([], groups);
    var filtered = (product.options || []).map(function (o) {
      return (o.values || []).some(function (val) {
        return filters.indexOf(val) !== -1;
      });
    });
    var hit = product.variants.find(function (v) {
      if (!v.available || !v.options) return false;
      return v.options.every(function (val, i) {
        return filtered[i] ? filters.indexOf(val) !== -1 : val === base.options[i];
      });
    });
    return hit ? String(hit.id) : '';
  }

  // Filtered grid (age pop-up): show the ad's colour in the picked size when it is in stock.
  function pinFilteredVariant(grid, productId, variantId) {
    var existing = findItems(grid, productId);
    var handle = existing.length ? handleFromItem(existing[0]) : '';
    var handlePromise = handle
      ? Promise.resolve(handle)
      : fetchCollectionProduct(collectionPath(grid), productId).then(function (product) {
          return product && product.handle ? product.handle : '';
        });
    return handlePromise.then(function (h) {
      if (!h) return false;
      return fetchProductJs(h).then(function (product) {
        var target = filteredVariantId(product, variantId);
        if (!target) return false;
        return fetchProductCard(h, target).then(function (html) {
          if (ensureAtTop(grid, productId, variantId)) return true;
          // Tagged with the ad variant so ensureAtTop / the grid observer keep this card on top
          return injectCard(grid, productId, html, variantId);
        });
      });
    });
  }

  var running = false;

  function runPin(options) {
    options = options || {};
    var allowFetch = options.allowFetch !== false;
    var grid = getGrid();
    var productId = getPinId();
    var variantId = getPinVariantId();
    if (!grid || !productId) return Promise.resolve(false);
    if (running) return Promise.resolve(false);
    running = true;

    if (ensureAtTop(grid, productId, variantId)) {
      running = false;
      return Promise.resolve(true);
    }

    if (variantId && hasActiveFilters()) {
      // Move the filter's own card now, then swap in the ad colour if that size is in stock.
      ensureAtTop(grid, productId, '');
      return pinFilteredVariant(grid, productId, variantId)
        .catch(function () {
          return false;
        })
        .finally(function () {
          running = false;
        });
    }

    if (!allowFetch || hasActiveFilters()) {
      // Filters pick the card's variant themselves; just move the card that is there.
      if (variantId) ensureAtTop(grid, productId, '');
      running = false;
      return Promise.resolve(false);
    }

    var existing = findItems(grid, productId);
    var handle = existing.length ? handleFromItem(existing[0]) : '';
    var handlePromise = handle
      ? Promise.resolve(handle)
      : fetchCollectionProduct(collectionPath(grid), productId).then(function (product) {
          return product && product.handle ? product.handle : '';
        });

    return handlePromise
      .then(function (h) {
        if (!h) return false;
        // Re-check DOM in case load-more raced
        if (ensureAtTop(grid, productId, variantId)) return true;
        return fetchProductCard(h, variantId).then(function (html) {
          if (ensureAtTop(grid, productId, variantId)) return true;
          return injectCard(grid, productId, html, variantId);
        });
      })
      .then(function (ok) {
        // Variant card failed: fall back to moving the normal card.
        if (!ok && variantId) return ensureAtTop(grid, productId, '');
        return ok;
      })
      .catch(function () {
        return false;
      })
      .finally(function () {
        running = false;
      });
  }

  function observeGrid() {
    var grid = getGrid();
    if (!grid || grid.getAttribute('data-bambe-pin-observed') === 'true') return;
    grid.setAttribute('data-bambe-pin-observed', 'true');
    var timer = null;
    var obs = new MutationObserver(function () {
      if (!getPinId()) return;
      clearTimeout(timer);
      timer = setTimeout(function () {
        ensureAtTop(getGrid() || grid, getPinId(), getPinVariantId());
      }, 50);
    });
    obs.observe(grid, { childList: true });
  }

  function init() {
    var pinId = getPinId();
    if (!pinId) return;
    rememberPin(pinId);
    observeGrid();
    runPin({ allowFetch: true });
  }

  window.BambeCollectionPin = {
    init: init,
    run: runPin,
    getPinId: getPinId,
    getPinVariantId: getPinVariantId,
    preserveParam: function (searchParams) {
      var pin = getPinId();
      if (!pin) return searchParams || '';
      try {
        var params = new URLSearchParams(searchParams || '');
        if (!params.has('p')) params.set('p', pin);
        var pinVariant = getPinVariantId();
        if (pinVariant && !params.has('v')) params.set('v', pinVariant);
        return params.toString();
      } catch (e) {
        return searchParams || '';
      }
    },
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('bambe:collection-grid-updated', function () {
    observeGrid();
    runPin({ allowFetch: !hasActiveFilters() });
  });

  document.addEventListener('shopify:section:load', function () {
    init();
  });
})();
